<template>
<div>
    <div class="entrance-video" v-for="(item, index) in items" v-bind:key="index">
        <div class="video-screen">
            <iframe :src="item.video"></iframe>
        </div>

        <div class="video-description">
            <h4>{{ item.title }}</h4>
            <p>{{ item.description }}</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          video: "https://www.youtube.com/embed/pgHPgmgr-ME",
          title: "mmyup",
          description: "yes",
        },
        {
          video: "https://www.youtube.com/embed/pgHPgmgr-ME",
          title: "mmyup",
          description: "yes",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.entrance-video {
  background-color: var(--secondary-background-color);
  display: flex;
  flex-direction: row;
  & > * {
    width: 50%;
  }
}
iframe {
  width: 75%;
}
</style>